module.exports = __webpack_public_path__ + "img/10.887da6cd.png";